import { createContext } from 'react'

import { Theme } from '@lyrahealth-inc/shared-app-logic'

export interface ForcedThemeState {
  /**
   * The currently forced theme. When null, the user's preference is used.
   * When set to Theme.DARK, this overrides the user's preference.
   */
  forcedTheme: Theme | null
  /**
   * Register a request to force dark mode. Each call must be paired with a
   * corresponding unregisterForcedDarkMode call. Dark mode is active as long
   * as at least one registration is outstanding.
   */
  registerForcedDarkMode: () => void
  /**
   * Release a previously registered dark mode request.
   */
  unregisterForcedDarkMode: () => void
}

export const ForcedThemeContext = createContext<ForcedThemeState>({
  forcedTheme: null,
  registerForcedDarkMode: () => {},
  unregisterForcedDarkMode: () => {},
})
